<div class="container">
    <div class="d-flex flex-column align-items-center justify-content-center">
        <h1 class="my-4">{{ Localization.Offline | translate }}</h1>
        <p>{{ Localization.OfflineMessage | translate }}</p>
        <chapps-secondary-button [label]="Localization.Reload | translate" [small]="true" (clicked)="reload()">
        </chapps-secondary-button>
    </div>
</div>
